$(document).ready(function() {

  if($('.collection-slider-item').length > 2){
    $('.collection-list-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      dots: false,
      prevArrow: '<div class="news__arrow news__arrow_dir_left"></div>',
      nextArrow: '<div class="news__arrow news__arrow_dir_right"></div>',
      responsive: [
        {
          breakpoint: 767,
          settings: {
             slidesToShow: 2,
          }
        },
        {
          breakpoint: 481,
          settings: {
             slidesToShow: 2,
          }
        }
      ]
    });
  }

  $('.gallery_slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    dots: false,
    prevArrow: '<div class="news__arrow news__arrow_dir_left"></div>',
    nextArrow: '<div class="news__arrow news__arrow_dir_right"></div>',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
  globle();

  

  // saving visited page links into localStorage for contact/quote form for sales dept.
  if (localStorage.getItem('customerHistory')) {

    let customerHistoryObject             = JSON.parse(localStorage.getItem('customerHistory'));
    let getUrl                            = window.location.href;
    let getTitle                          = document.title.split("–")[0].trim();
    let customerHistoryObjectDuplicate    = false;

    customerHistoryObject.forEach(function(item, index) {
      if (item.url === getUrl || getTitle === "ZT Labels") {
        customerHistoryObjectDuplicate = true;
      }
    });

    if (customerHistoryObjectDuplicate == false) {
      if (customerHistoryObject.length > 9) {
        customerHistoryObject.shift();
      }
      customerHistoryObject.push({
        url: getUrl,
        title: getTitle
      });
      localStorage.setItem('customerHistory', JSON.stringify(customerHistoryObject));
    }

  }else{
    if (document.title !== "ZT Labels") {
      localStorage.setItem('customerHistory', '[{"url": "'+window.location.href+'", "title":"'+document.title.split("–")[0].trim()+'"}]');
    }
  }
  



  // ajax call for contact form
  $("#contactForm").submit(function (event) {
      
    event.preventDefault();
    document.querySelector(".contact-form form button[type=submit].button").disabled = true;
    $('.ContactPageOverlay').addClass('is-visible');
    let data = $("#contactForm").serializeControls();
    let form_data = $("#contactForm").serializeControls();
    
    const send = {
        'form': data,
    }
    
    $.ajax({
        type: "POST",
        url: "https://zippertubing.us/zipper-technik/contact_form/index.php",
        data: JSON.stringify(send),
        // dataType: "json",
        contentType: 'application/json',
        encode: true,
    }).done(function (data) {
        $('.ContactPageOverlay').removeClass('is-visible');
          if (form_data.locale == 'de') {
            window.location.href = '/pages/danke-dass-sie-uns-kontaktiert-haben';
          }else{
            window.location.href = '/en/pages/danke-dass-sie-uns-kontaktiert-haben';
          }
        }).fail(function (e) {
            alert('An error occured. Please try again.');
            $('.ContactPageOverlay').removeClass('is-visible');
    });

  });



  // add google map link on footer
  let locationLink = $(".footer .location_text").text().replace(/\n/g, '').trim();
  $(".footer .location_text").html("<a href='https://goo.gl/maps/VrQrEPh2eyytEeHs8' target='_blank'>"+locationLink+"</a>");



  // ajax call for quote form
  $("#quoteForm").submit(function (event) {
    
      event.preventDefault();
      $('.QuoteFormOverlay').addClass('is-visible');
    
      let quoteData = JSON.parse(localStorage.getItem('quoteList'));
      let data = $("#quoteForm").serializeControls();
      let form_data = $("#contactForm").serializeControls();

      const send = {
          'form': data,
          'quote': quoteData
      }

      $.ajax({
          type: "POST",
          url: "https://zippertubing.us/zipper-technik/quote_form/index.php",
          data: JSON.stringify(send),
          // dataType: "json",
          contentType: 'application/json',
          encode: true,
      }).done(function (data) {
          $('.QuoteFormOverlay').removeClass('is-visible');
          $('.quotable').removeClass('open');
          $('.PageOverlay').removeClass('is-visible');
          localStorage.removeItem('quoteList');        
          if (form_data.locale == 'de') {
            window.location.href = '/pages/vielen-dank-fur-ihre-angebotsanfrage';
          }else{
            window.location.href = '/en/pages/vielen-dank-fur-ihre-angebotsanfrage';
          }
      }).fail(function () {
          alert('An error occured. Please try again.');
          $('.QuoteFormOverlay').removeClass('is-visible');
      });
    
  });



  $('.getAQuote').on('click', function () {
    quoteDrawer();
    $('.quotable').addClass('open');
    $('.PageOverlay').addClass('is-visible');
  });

  $('.Quote__Close, .PageOverlay').on('click', function () {
      $('.quotable').removeClass('open');
      $('.PageOverlay').removeClass('is-visible');
  });

  $('.quotable .step1 .btn').on('click', function () {
     $('.quotable .step1').hide();
      $('.quotable .step2').show();
  });

  $('.quotable .step2 button.Drawer__Back').on('click', function () {
     $('.quotable .step1').show();
      $('.quotable .step2').hide();
  });

  $('body').on('click', '.delete-quote-product', function () {
      const index = $(this).data('index');
      let retrievedObject = JSON.parse(localStorage.getItem('quoteList'));
      retrievedObject.splice(index, 1);
      localStorage.setItem('quoteList', JSON.stringify(retrievedObject));
      quoteDrawer();
  });


  /*** product page Get a Quote button ***/
  if (document.location.pathname.includes("products") === true && document.querySelectorAll(".price-item.price-item--regular").length === 0 && document.querySelector(".product-form form")) {

    document.querySelector(".product-form form").style.display = "none";
    document.querySelector(".product-form__buttons.hidden").classList.remove('hidden')

    // let vairantId = document.querySelector(".product-form form input[name=id]").value;
    // let getaQuoteBtn = '<div class="product-form__buttons"><button type="submit" name="add" title="Get A Quote" class="product-form__submit button getAQuoteButton button--full-width button--secondary" data-variant-id="'+vairantId+'" aria-haspopup="dialog"><span>Get a Quote</span><div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div></button></div>';
    // $(".product-form").append(getaQuoteBtn);

  }


  window.addEventListener('load', function () {

    $('.getAQuoteButton').on('click', function () {
      quoteDetails();
      setTimeout(function () {
        quoteDrawer();
        $('.quotable').addClass('open');
        $('.PageOverlay').addClass('is-visible');
      }, 300)
    });

  });

  quoteTab();


});



$.fn.serializeControls = function() {
  var data = {};

  function buildInputObject(arr, val) {
    if (arr.length < 1)
      return val;
    var objkey = arr[0];
    if (objkey.slice(-1) == "]") {
      objkey = objkey.slice(0,-1);
    }
    var result = {};
    if (arr.length == 1){
      result[objkey] = val;
    } else {
      arr.shift();
      var nestedVal = buildInputObject(arr,val);
      result[objkey] = nestedVal;
    }
    return result;
  }

  $.each(this.serializeArray(), function() {
    var val = this.value;
    var c = this.name.split("[");
    var a = buildInputObject(c, val);
    $.extend(true, data, a);
  });

  return data;
}


equalheight = function(container) {
  if (jQuery(window).resize() > 320) {
    var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = new Array(),
        jQueryel

    jQuery(container).each(function() {
      jQueryel = jQuery(this);
      jQuery(jQueryel).innerHeight('auto')
      rowDivs.push(jQueryel);
      currentTallest = (currentTallest < jQueryel.innerHeight()) ? (jQueryel.innerHeight()) : (currentTallest);

      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
          rowDivs[currentDiv].innerHeight(currentTallest);
      }
    });
  } else {
    jQuery(container).height('auto');
  }
}



function globle() {
  equalheight('.product-grid .product-card-wrapper .card__heading a');
}

$(".hasMega .mobile-toggle").click( function (){
  $(this).next('.dropdown_container').slideToggle(500);
  $(this).toggleClass("active");
  $(this).parent().siblings().find('.dropdown_container').hide();
  $(this).parent().siblings().find('.hasMega .mobile-toggle').removeClass("active");
});

$(".sub-nav-heading-mob").click( function (){
  $(this).next('.dropdown-wraper').slideToggle(500);
  $(this).toggleClass("active");
  $(this).parent().siblings().find('.dropdown-wraper').hide();
  $(this).parent().siblings().find('.sub-nav-heading-mob').removeClass("active");
});


function closeThemeCart(){
  $(".drawer__header button.drawer__close").trigger("click");
}


 function quoteDrawer() {
   
    let items;
    let finalHtml = '';

    if (localStorage.getItem('quoteList') && localStorage.getItem('quoteList') !== '[]') {
        let retrievedObject = JSON.parse(localStorage.getItem('quoteList'));

        retrievedObject.map(function (item, index) {
            finalHtml += '<div class="quotable__product">\n' +
                '      <div class="delete-quote-product" style="font-size: 12px;" data-index="'+index+'">' +
                // '<svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">\n' +
                // '        <path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>\n' +
                // '      </svg>' +
                '<u>Remove</u>' +
                '</div>' +
                '        <div class="row">\n' +
                '          <div class="column">\n' +
                '            <div class="quotable__image">\n' +
                '              <img src="'+item.image+'" alt="Product Image">\n' +
                '            </div>\n' +
                '          </div>\n' +
                '          <div class="column">\n' +
                '            <div class="quotable__variant">\n' +
                '              <p class="quote-item"><span><a href="'+item.itemURL+'">'+item.title+'</a></span></p>\n' +
                '            </div>\n';
            
            if (item.variant != "") {
            finalHtml +='    <div class="quotable__variant">\n'+
                '               <p class="quote-variants quote_attributes"><strong>Selected Options:</strong> '+item.variant+'</p>\n' +
                '            </div>\n';
            }
            finalHtml +='    <div class="quotable__variant quote_attributes">\n' +
                '               <p><strong>Quantity:</strong> '+item.qty+'</p>\n' +
                '            </div>\n' +
                '          </div>\n' +
                '        </div>\n' +
                '      </div>';
        });
        $('.quotable .step1 .quote__products').html(finalHtml);
        $('.quotable .step1 .btn').show();
    } else {
        $('.quotable .step1 .quote__products').html('<p>Your list is empty.</p>');
        $('.quotable .step1 .btn').hide();
    }

    quoteTab();

}




function quoteDetails() {

  let productTitle  = $("div.product__title h1").text();
  let variantHtml   = '';
  let itemURL       = window.location.href;
  let itemQty       = $(".product-form__quantity .quantity__input").val();
  let productImg    = $(".product__media img").attr('src').split("?")[0] + "?width=100";


  const total = $('div.select').length;
  $('div.select').each(function (index) {
    if (index !== total - 1) {
      variantHtml += $(this).find(":selected").text().trim() + ', ';
    } else {
      variantHtml += $(this).find(":selected").text().trim();
    }
  });

  const element = [
    {
      "title"   : productTitle,
      "variant" : variantHtml,
      "image"   : productImg,
      "itemURL" : itemURL,
      "qty"     : itemQty
    }
  ]

  if (localStorage.getItem('quoteList')) {

    let retrievedObject = JSON.parse(localStorage.getItem('quoteList'));
    let objDuplicate    = false;

    if (retrievedObject.length == 0) {
      retrievedObject.push({
        "title"   : productTitle,
        "variant" : variantHtml,
        "image"   : productImg,
        "itemURL" : itemURL,
        "qty"     : itemQty
      });
      localStorage.setItem('quoteList', JSON.stringify(retrievedObject));

    }else{
      
      retrievedObject.forEach(function(item, index) {        
        if (item.title === productTitle && item.variant === variantHtml && item.qty === itemQty) {
          objDuplicate = true;
        }
      });

      if (objDuplicate == false) {
        retrievedObject.push({
          "title"   : productTitle,
          "variant" : variantHtml,
          "image"   : productImg,
          "itemURL" : itemURL,
          "qty"     : itemQty
        });
        localStorage.setItem('quoteList', JSON.stringify(retrievedObject));
      }

    }
  } else {
    localStorage.setItem('quoteList', JSON.stringify(element));
  }


}

function quoteTab() {
  if (localStorage.getItem('quoteList') !== null) {
    let quoteQty = JSON.parse(localStorage.getItem('quoteList')).length;
    document.querySelectorAll(".quoteCart.getAQuote .quoteQty")[0].innerText = quoteQty;
    if (quoteQty > 0) {
        $(".quoteCart.getAQuote").show();
    }else{
        $(".quoteCart.getAQuote").hide();        
    } 
  }
}

